<template>
<div>
{{dataerror}}
<input multiple type="file" id="uploadpic" @change="onimgSelected($event)" accept="image/*;capture=camera" />
<h1> <a href="javascript:OneChat_WebCommand_CloseWebview();">close webview</a> </h1> <br/>
<!-- <a href="javascript:connectServiceByUUID();">connectServiceByUUID</a><br/>
<a href="javascript:readCharacteristicByUUID();">readCharacteristicByUUID</a><br/>
<a href="javascript:writeCharacteristicByUUID();">writeCharacteristicByUUID</a> -->
=================================================================
<p id="state"></p>
<span id="list_deveiceservice"></span>

<h1> <a href="javascript:OneChat_scanBeaconByUUID('c8a94f42-3cd5-483a-8adc-97473197b8b4');">Beacon น้องโอ</a> </h1> <br/>
<h1> <a href="javascript:OneChat_stopBeaconByUUID('c8a94f42-3cd5-483a-8adc-97473197b8b4');">StopBeacon น้องโอ</a> </h1> <br/>

<h1> <a href="javascript:OneChat_RequestProfileData();">Testjam</a> </h1> <br/>
{{mamalist}}



<!-- <v-btn @click="momo">test</v-btn> -->
<!-- {{checkuserAgent()}} -->
<!-- {{mamo}} -->
========
<!-- return_once_device
{{return_once_device}} -->
===========================
<!-- {{test}} -->



<h1> <a href="javascript:OneChat_scanDevice(5000);">scan Device</a> </h1> <br/>

<h1> <a @click="OneChat_scanDevice_vue()">scan Device</a> </h1> <br/>

<h1> <a href="javascript:OneChat_stopScanDevice('success');">stop scan</a> </h1> <br/>
<h1> <a href="javascript:OneChat_disconnectBluetoothAll('success');">disconnect</a> </h1> <br/>
<h1> <a href="javascript:OneChat_disconnectBluetoothByUUID('fbe24bbf-0599-368d-92ab-4692da9e0ed8');">disconnectUUID ขนุน</a> </h1> <br/>
device list
{{mamo}}
================
{{uuid_device01}}-----{{uuid_device02}}
<h1> <a @click="OneChat_getPrimaryService_vue()">Device ขนุน</a> </h1> <br/>
<h1> <a @click="OneChat_getPrimaryService_vue2()">Device jam</a> </h1> <br/>
<h1> <a href="javascript:OneChat_getPrimaryService('8174B682-CF07-48B7-94DB-A6785CA078D7');">Device พี่นัท</a> </h1> <br/>
<br/>
================

service list
{{service}}
<h1> <a href="javascript:OneChat_connectServiceByUUID('7800b317-e65c-3561-ab22-a9ef256fe7bb','5b5c170c-9637-4045-b9fe-cd89b0cf0214');">connectServiceByUUID ขนุน</a> </h1> <br/>

<h1> <a href="javascript:OneChat_connectServiceByUUID('4126FB19-261E-2568-F309-91ECBB8EE3CE','F000FFC0-0451-4000-B000-000000000000');">connectServiceByUUID แจม</a> </h1> <br/>

<h1> <a href="javascript:OneChat_getCharacteristic('5b5c170c-9637-4045-b9fe-cd89b0cf0214');">getCharacteristic ขนุน</a> </h1> 
<h1> <a href="javascript:OneChat_getCharacteristic('F000FFC0-0451-4000-B000-000000000000');">getCharacteristic jam</a> </h1> 
<h1> <a href="javascript:OneChat_getCharacteristic('ADE8438A-E94B-4B3D-9CB1-346D689CB5C7');">getCharacteristic พี่นัท</a> </h1> <br/>
================
charact list
{{charact}}

<h1> <a href="javascript:OneChat_readCharacteristic('00001800-0000-1000-8000-00805f9b34fb');">read Characteristic พี่นัท</a> </h1> <br/>
<h1> <a href="javascript:OneChat_writeCharacteristic('E0796F74-FAD3-4A6D-883B-722F584A394C','Hello jam','text');">write Characteristic ขนุน</a> </h1> <br/>

<!-- '4126FB19-261E-2568-F309-91ECBB8EE3CE','4126FB19-261E-2568-F309-91ECBB8EE3CE' -->
================


<h1> <a href="javascript:OneChat_readCharacteristicByUUID('8174B682-CF07-48B7-94DB-A6785CA078D7','ADE8438A-E94B-4B3D-9CB1-346D689CB5C7','00001800-0000-1000-8000-00805f9b34fb');">read CharacteristicUUID พี่นัท</a> </h1> <br/>


<h1> <a href="javascript:OneChat_writeCharacteristicByUUID('7800b317-e65c-3561-ab22-a9ef256fe7bb','5b5c170c-9637-4045-b9fe-cd89b0cf0214', 'E0796F74-FAD3-4A6D-883B-722F584A394C','Hello jam','text');">write CharacteristicUUID ขนุน</a> </h1> <br/>
================


<!-- <h1> <a href="javascript:OneChat_readCharacteristic('5b5c170c-9637-4045-b9fe-cd89b0cf0214');">readCharacteristic</a> </h1> <br/> -->


<!-- <h1> <a :href="OneChat_getPrimaryService('5396fd99-033d-3dbc-b8c9-42df0cfe25ca')">Device พี่นัท</a> </h1> <br/> -->
<!-- <h1> <a href="javascript:OneChat_getPrimaryService('2732f23b-d4c9-3def-8359-36e63dfa9ca2');">Device 2732f23b พี่นัท</a> </h1> <br/> -->
<!-- <span id="listdevice"></span> -->
<!-- <h1> <a href="javascript:helloandroid('kiki');">scan Device</a> </h1> <br/> -->
<!-- <br/><h1> <a href="javascript:getPrimaryService();">select Device01</a> </h1> <br/>
<span id="listservice"></span>

<br/><h1> <a href="javascript:getCharacteristic();">select Service01</a> </h1> <br/>
<span id="listcharacteristic"></span>

<br/><h1> <a href="javascript:readCharacteristic();">read</a> </h1> <br/>

<br/><input type="text" id="write_characteristic" placeholder="กรอกข้อมูล" style="width: 50%; color: black; padding: 14px 20px; margin: 8px 0; border: 1px solid black; border-radius: 4px;">
<h1> <a href="javascript:writeCharacteristic();">write</a> </h1> <br/>
 -->

<a href="https://chat-api.one.th/go_api/api/v1/openScanQRcodeWithValue" target="_blank">open qrcode</a>
<span id="dataQrcode"></span>

<!-- <v-btn @click="test()">test</v-btn ><br/> -->
<!-- <span id="listdevice"></span> -->



</div>
</template>

<script>

// var uuid_device02 = '12345678'

export default {
  data: function() {
    return {
      data: '',
      device: '',
      service: '',
      charact: '',
      test: '',
      uuid_device01: '',
      uuid_device02: '',
      return_once_device: '',
      mamo: [],
      mamalist: {},
      selectFile: [],
      dataerror: 'test'
      // get token() {
      //   return localStorage.getItem('uuid_device01') || 0;
      // },
      // set token(value) {
      //   localStorage.setItem('uuid_device01', value);
      // }
    }
  },
  created () {
    OneChat_RequestProfileData()
  },
  watch: {
  },
  computed:{
  },
  // components: {
  //   uuid_device01: uuid_device01
  // },
  mounted() {
    window.addEventListener('oneChatCallBackQRScanner', async (e) => {
      alert(e.detail.qrcode) 
    })
    window.addEventListener('oneChatBeaconCallBackData', async (e) => {
      // alert(e.detail) 
      this.mamalist = e.detail
    })
    window.addEventListener('oneChatProfileData', async (e) => {
      // alert(e.detail) 
      this.mamalist = e.detail
    })
    window.addEventListener('oneChatBluetoothCallBackData', async (e) => {
      this.data = e.detail
      var data = e.detail.data
      var type = e.detail.type
      try {
        if (type == 'get_device_service') {
          this.device = this.data
          var obj = JSON.parse(this.data.data)
          // alert(obj)
          // OneChat_getPrimaryService(obj.data[0].uuid)
          // var message = '<u>รายชื่ออุปกรณ์ </u><br/>'
          // this.uuid_device01 = obj[0].uuid
          for (var i = 0; i < obj.length; i += 1) {
            if (obj[i].bluetooth_name == 'Health Thermometer') {
              alert(obj[i])
              this.uuid_device01 = obj[i].uuid
            }
          }
          // document.getElementById("listdevice").innerHTML=message;
        } else if (type == 'get_service') {
          this.service = this.data
        } else if (type == 'return_once_device') {
          // var obj = JSON.parse(data)
          // alert(obj)
          this.mamo.push(this.data)
          this.return_once_device = this.data
          // if (JSON.parse(data).bluetooth_name == 'Health Thermometer') {
          //   alert(JSON.parse(data))
          //     this.uuid_device02 = JSON.parse(data).uuid
          //   }
          // this.test = JSON.parse(this.data.data)
          // alert(obj)
        }
        //   var obj = this.data
        //   var message = '<u>รายชื่อบริการ </u><br/>'
        //   uuid_service01 = obj.uuid[0]
        //   for (var i = 0; i < obj.length; i += 1) {
        //     message = message + '<p>' + obj.uuid[i] + '</p>'
        //   }
        //   document.getElementById("listservice").innerHTML=message;
        // } else if (type == 'get_characteristic') {
        //   var obj = this.data
        //   var message = '<u>รายชื่อcharacteristic</u><br/>'
        //   for (var i = 0; i < obj.length; i += 1) {
        //     message = message + '<p>' + obj[i].uuid + '(' + obj[i].type + ')</p>'
        //     if (obj[i].type == 'read') {
        //       uuid_characteristic_read = obj[i].uuid
        //     } else if (obj[i].type == 'write') {
        //       uuid_characteristic_write = obj[i].uuid
        //     }
        //   }
        //   document.getElementById("listcharacteristic").innerHTML=message;
        // } else if (type == 'read_characteristic') {
        //   alert(this.data)
        // } else if (type == 'write_characteristic') {
        //   alert(this.data)
        // }
      } catch(error) {
          alert(error)
      }
    })

  },
  methods: {
    onimgSelected(data) {
      let uploadedFiles = data.target.files
      var Authorization = {headers: {'Authorization': 'Bearer A7c912b3d4c1559daaee85600ceab21df1426b90b21c24876ba2579822588ed9f4217566a6d6c4012acf1b547893ff2e0'}}
      // var lengthfile = uploadedFiles.length
      // var sizefile = []
      this.dataerror = 'mama' + uploadedFiles[0].size
      for (let i = 0; i < uploadedFiles.length; i++) {
        this.selectFile = data.target.files[i]
        var uploadFile = new FormData()
        uploadFile.append('file', this.selectFile, this.selectFile.name)
        uploadFile.append('bot_id', 'Bd8f1670489935d9199c22a686943f711')
        uploadFile.append('to', 'U60af97ed5e255a979e5ec83eac46f446')
        uploadFile.append('type', 'file')
        // this.dataerror = 'mamamomo' 
        // try {
        this.$http.post('https://testchat.one.th/message/api/v1/push_message', uploadFile, Authorization).then((response) => {
          console.log(response.data)
          this.dataerror = 'success'
        }).catch(error => {
          this.dataerror = error
          this.$swal('', 'เกิดความผิดปกติบางอย่างขึ้น กรุณาลองใหม่ในภายหลัง', 'error')
        })
      }
    },
    OneChat_scanDevice_vue () {
      OneChat_scanDevice(5000)
    },
    OneChat_getPrimaryService_vue () {
      OneChat_getPrimaryService(this.uuid_device01)
    },
    OneChat_getPrimaryService_vue2 () {
      OneChat_getPrimaryService(this.uuid_device02)
    },
    momo() {
      this.test = JSON.parse("{\"data\":{\"uuid\":\"446ce5f9-8483-3a99-a065-4e75cdcd6e74\",\"bluetooth_name\":\"null\",\"manufacturer_data\":\"{length = 14, bytes = 0x004C1005551c3d6394 }\",\"manufacturer_data_hexa\":\"004C1005551c3d6394\",\"rssi\":-64,\"address\":\"47:CE:D5:D5:DC:31\",\"state\":0},\"type\":\"return_once_device\"}")
      // alert(type)
      // console.log(uuid_device02)
      // uuid_device02 = 'test123455'
      // console.log(uuid_device02)
    }
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/test6.vue